<template>
  <div id="main">
    <div id="manu">
      <navigation />
    </div>
    <div id="contentBox">
      <div class="container">
        <h2>注册</h2>
        <el-form :model="user" :rules="rules" ref="registerForm" @submit.prevent="register">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="user.username" placeholder="请输入用户名" />
          </el-form-item>
          <el-form-item label="邀请码" prop="inviteCode">
            <el-input v-model="user.inviteCode" placeholder="请输入邀请码" />
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="user.email" placeholder="请输入邮箱" type="email" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="user.password" placeholder="请输入密码" />
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input type="password" v-model="user.confirmPassword" placeholder="请确认密码" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="isSubmitting" @click="register">注册</el-button>
          </el-form-item>
        </el-form>
      </div>
      <footer />
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';

export default defineComponent({
  name: 'Register',
  setup() {
    const user = reactive({
      username: '',
      inviteCode: '',
      email: '',
      password: '',
      confirmPassword: '',
      deviceName: ''
    });

    const registerForm = ref(null);
    const isSubmitting = ref(false);

    const rules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' },
        { pattern: /^[a-zA-Z0-9]+$/, message: '用户名只能包含英文和数字', trigger: 'blur' }
      ],
      inviteCode: [
        { required: true, message: '请输入邀请码', trigger: 'blur' },
        { len: 8, message: '邀请码为 8 个字符', trigger: 'blur' }
      ],
      email: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        { type: 'email', message: '邮箱格式无效', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { 
          pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{7,}$/, 
          message: '密码必须包含英文和数字，且最少 7 位', 
          trigger: 'blur' 
        }
      ],
      confirmPassword: [
        { required: true, message: '请确认密码', trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            if (value !== user.password) {
              callback(new Error('两次输入的密码不一致'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }
      ]
    };

    const getDeviceName = () => {
      const ua = navigator.userAgent;
      let device = '未知设备';
      if (/mobile/i.test(ua)) {
        device = /android/i.test(ua) ? 'Android设备' : /iphone|ipad|ipod/i.test(ua) ? 'iOS设备' : '移动设备';
      } else {
        device = /windows/i.test(ua) ? 'Windows PC' : /macintosh|mac os x/i.test(ua) ? 'Mac PC' : 'PC';
      }
      return device;
    };

    user.deviceName = getDeviceName();

    const register = async () => {
      try {
        await registerForm.value.validate();
        isSubmitting.value = true;
        const response = await axios.post('https://a.410121.xyz/api/register', {
          username: user.username,
          inviteCode: user.inviteCode,
          email: user.email,
          password: user.password,
          deviceName: user.deviceName
        });
        if (response.data.code === 201) {
          ElMessage.success('注册成功，请登录');
          return { name: 'Login' }; // 返回路由对象，需在组件外处理跳转
        } else {
          throw new Error(response.data.message || '注册失败');
        }
      } catch (error) {
        ElMessage.error(error.response?.data?.message || error.message || '网络错误');
      } finally {
        isSubmitting.value = false;
      }
    };

    return {
      user,
      rules,
      registerForm,
      isSubmitting,
      register
    };
  }
});
</script>

<style scoped>
.container {
    width: 400px;
    margin: 100px   auto;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border: 1px solid #ccc;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
  }
  .container h2{
    text-align: center;
    margin-bottom: 20px;
  }
  input[type="text"], input[type="email"], input[type="password"] {
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    box-sizing: border-box;
    margin: 10px 0;
  }
  
  button {
    width: 100%;
    background-color: blue;
    color: white;
    padding: 10px;
    border: none;
    text-align: center;
    cursor: pointer;
  }
  
</style>>